import { Clone, useGLTF } from '@react-three/drei';
import { FoliageMaterial } from './foliage-material';

export default function Tree(props) {
  const tree = useGLTF('./tree.glb');

  return (
    <group {... props} dispose={null}>
      <Clone
        object={tree.nodes.trunk}
        inject={<meshBasicMaterial color="#290805" />}
      />
      <Clone 
        receiveShadow 
        castShadow 
        object={tree.nodes.foliage} 
        inject={<FoliageMaterial />} 
      />
    </group>
  );
}
